import { render, staticRenderFns } from "./MagicInput.vue?vue&type=template&id=70c876ec&scoped=true"
import script from "./MagicInput.vue?vue&type=script&lang=js"
export * from "./MagicInput.vue?vue&type=script&lang=js"
import style0 from "./MagicInput.vue?vue&type=style&index=0&id=70c876ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c876ec",
  null
  
)

export default component.exports